import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/logo/iknowa-logo-v4.svg'
import _imports_1 from '../../../assets/icons/tick.svg'


const _withScopeId = n => (_pushScopeId("data-v-180def08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth_wrapper" }
const _hoisted_2 = { class: "form-container-default left-block" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "open-logo",
    src: _imports_0
  })
], -1))
const _hoisted_4 = { class: "form_wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "" }, "Forgot Password")
], -1))
const _hoisted_6 = { class: "right_block" }
const _hoisted_7 = { class: "right_block_content" }
const _hoisted_8 = { class: "inner-content" }
const _hoisted_9 = { class: "login_img" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "login_content" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "description" }
const _hoisted_14 = { class: "benifit_points" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_1
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ForgotPassFormComponent = _resolveComponent("ForgotPassFormComponent")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_AuthIknowaInfoMobileModal = _resolveComponent("AuthIknowaInfoMobileModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["form-container-main", { mobileView: $setup.isShowAuthIknowaInfoMobile && $setup.isMoblieView }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_ForgotPassFormComponent)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_carousel, {
          "indicator-position": "outside",
          autoplay: false,
          arrow: "never",
          class: "",
          trigger: "click"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.carouselItem, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                key: index,
                class: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("img", {
                          class: "open-logo",
                          src: require(`../../../assets/images/${item?.image}.png`)
                        }, null, 8, _hoisted_10)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("h2", _hoisted_12, _toDisplayString(item?.title), 1),
                        _createElementVNode("p", _hoisted_13, _toDisplayString(item?.description), 1),
                        _createElementVNode("div", _hoisted_14, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(item?.benefits), (desc, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "benifit_points_list",
                              key: i
                            }, [
                              _hoisted_15,
                              _createElementVNode("p", null, _toDisplayString(item?.benefits[desc]), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      ($setup.isShowAuthIknowaInfoMobile)
        ? (_openBlock(), _createBlock(_component_AuthIknowaInfoMobileModal, {
            key: 0,
            onOnCloseButtonClick: $setup.onCloseButtonClick
          }, null, 8, ["onOnCloseButtonClick"]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}